






































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { v4 as uuidv4 } from "uuid";
import { isPig } from "@dokogd/shared";
import { Dictionary } from "lodash";
// // isPig
@Component({})
export default class DoKoCard extends Vue {
  readonly card_id = uuidv4();
  readonly PIG_SIZE = 400;
  readonly VALUE_MAPPING: Dictionary<string> = {
    A: "A",
    X: "10",
    K: "K",
    Q: "D",
    J: "B",
    "9": "9",
  };
  readonly COLOR_MAPPING: Dictionary<string> = {
    "♣": "kreuz",
    "♠": "pik",
    "♥": "herz",
    "♦": "karo",
  };
  over = false;

  @Prop({
    type: Boolean,
    default: false,
  })
  private hoverable!: boolean;

  get back(): boolean {
    return this.name === "back";
  }

  // ('♣', 'black'), ('♠', 'black'), ('♥', '#d6002b'), ('♦', '#d6002b')
  // ('A', 'A'), ('10', '10'), ('9', '9'), ('K','K'), ('D','Q'), ('B','J')
  @Prop({
    type: String,
    default: "back",
  })
  private name!: string;

  get pig() {
    return isPig(this.name);
  }

  get pigType() {
    if (["♣", "♠"].includes(this.color)) {
      return "wildschwein";
    } else {
      return "schwein";
    }
  }

  get color() {
    if (this.back) {
      return "";
    } else {
      return this.name[0];
    }
  }

  get colorSymbol() {
    return "/img/symbols.svg#symbol-" + this.COLOR_MAPPING[this.color];
  }

  get value() {
    if (this.back) {
      return "";
    } else {
      return this.VALUE_MAPPING[this.name[1]];
    }
  }

  // 110x182
  // 735x1215
  @Prop({
    type: Number,
    default: 110 / 735,
  })
  private scale!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private x!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  private y!: number;

  get width() {
    return this.scale * 735;
  }
  get height() {
    return this.scale * 1215;
  }

  get coloring() {
    return ["♥", "♦"].includes(this.color) ? "#d6002b" : "#000";
  }

  get textStyle() {
    return {
      fill: this.coloring,
      fontSize: "144px",
      textAnchor: "middle",
      textAlign: "center",
    };
  }

  get calcY() {
    return this.hoverable && this.over ? this.y - 20 : this.y;
  }
  get transformText() {
    return `translate(${this.x} ${this.calcY}) scale(${this.scale})`;
  }

  cardClicked() {
    this.$emit("click", this.name);
    console.log("cardClicked", this.name, this.pig);
  }
}
